import { FC, useMemo, Fragment } from 'react';
import { Row } from 'antd';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import V2Title from '@/common/components/Feedback/V2Title';
// import V2Anchor from '@/common/components/Others/V2Anchor';
import PropertyComponent from './PropertyComponent';
import cs from 'classnames';
import styles from './index.module.less';
import { isShowWhenApprovalProcess } from './hooks/useAccessIsShow';
import { ControlType } from './config';

// const { Link } = Anchor;

/**
 * TODO(2026-1029迭代/机会点表单字段必填/可见/可写，文档：https://confluence.lanhanba.com/pages/viewpage.action?pageId=172107370)：
 * 评估动态字段渲染时 isShow、可编辑权限和 required 配置的映射，确认规则应由接口配置、审批流程状态还是前端租户逻辑决定。
 *
 * 动态表单组件
 * @Description 区分不同的组件类型
 * supportDirectApproval的说明 该字段是通用审批流中，用来控制字段的可读/可写
 * @category Form
 */
const DynamicComponent: FC<{
  formData,
  wholeFormData,
  // anchorCustomStyle = {},
  // tabContentRefs,
  // active = '', // 目前处理在isLongList为true时才有用到
  // scrollAccordingTab = false, // 长列表tab点击时自动滚动，目前处理在isLongList为true时且初始化完成后手动点击时才为true
  // 以下参数单纯都是给PropertyCompoennt使用的
  form,
  isChancepoint?: boolean,
  /** 关联踩点记录仅在机会点创建、编辑表单中展示。 */
  showAssociatedRecords?: boolean,
  /** 是否传统的点位评估编辑页（不包含一鸣等租户走机会点点位评估审批流的场景），是的话字段参照拓店模板设置，而不是流程配置 */
  isTraditionEvaluation?: boolean,
  /** 表单是否检查必填项，true检查，false只检查特定identification必填字段 */
  // needCheck: boolean,
  /** 是否长表单形式展示 */
  isLongList?: boolean,
  addressChange?,
  /** 地图移动事件 */
  mapMoveChange?,
  /** 地图缩放事件 */
  mapZoomChange?,
  /** 自定义组件（周边查询、商圈规划、周边竞品等）变动时，更新componentValue */
  updateCompValue?,
  /** 选择框组件关联变更触发（比如 取消选中） */
  updateRelateShow?,
  /** 是否支持直接提交审批 1:支持 2:不支持，默认值是2 */
  supportDirectApproval?,
  /** 在编辑状态下，踩点组件是否已有数据（已有数据则设置表单不可读） */
  isFootprintValue?: boolean,
  /** 商圈规划组件数据：地址变动时外部传入的商圈数据 */
  businessPlanValue?,
  /** 商圈信息数据：地址变动时外部传入的商圈数据 */
  businessInfoValue?,
  /** 单选、多选、输入框等值变更时的提示内容 */
  showHintStr?,
  /** 是否有区域保护 */
  isAreaProtect?,
  /** 当前区域保护特殊申请状态；未配置区域保护时保持 undefined。 */
  antiCollisionApprovalStatus?: number,
  /** 地址组件本次变更的即时坐标。 */
  addressVal?,
  /** 机会点表单使用（卡旺卡预估销售额）,该组件还被其他页面引用，其他页面是不会传该参数 */
  salesFactorOfKWK?,
  /** 机会点表单使用（卡旺卡预估销售额） */
  setSalesFactorOfKWK?,
  /** 是否编辑过机会点名称 */
  isEditedBasicChancePointName?,
  /** 更新：是否编辑过机会点名称 */
  setEditedBasicChancePointName?,
  /** 所有组件字段平铺后的对象数组；使用 formDataComsToTiled 将动态表单中的所有组件平铺到数组中，方便查找到对应的组件 */
  tiledFormDataRef?,
  /** 益禾堂定制组件属性-人口流量获取匹配商圈中的集客点的商圈类型 */
  customGatheringCategoryForYHT?,
  /** 更新：益禾堂定制组件属性-人口流量获取匹配商圈中的集客点的商圈类型 */
  setCustomGatheringCategoryForYHT?,
  /** 禁用开店区域点击查看详情 */
  disabledArea?,
  /** 编辑状态：true 编辑，false 新增 */
  isEdit?: boolean,
  /** 拓店任务商圈id */
  expansionTaskClusterId?,
  /** 区域保护检测结果变更后，更新详情顶部操作 */
  onAreaProtectionCollisionChange?: (hasCollisionWithin200m: boolean | undefined) => void,
}> = ({
  formData,
  wholeFormData,
  // anchorCustomStyle = {},
  // tabContentRefs,
  // active = '', // 目前处理在isLongList为true时才有用到
  // scrollAccordingTab = false, // 长列表tab点击时自动滚动，目前处理在isLongList为true时且初始化完成后手动点击时才为true
  // 以下参数单纯都是给PropertyCompoennt使用的
  form,
  isChancepoint = true,
  showAssociatedRecords = false,
  isTraditionEvaluation = false,
  // needCheck = true, // 表单是否检查必填项，true检查，false只检查特定identification必填字段
  isLongList = false, // 是否长表单形式展示
  addressChange,
  mapMoveChange, // 地图移动事件
  mapZoomChange, // 地图缩放事件
  updateCompValue,
  updateRelateShow,
  supportDirectApproval, // 是否支持直接提交审批 1:支持 2:不支持，默认值是2
  isFootprintValue = false, // 在编辑状态下，踩点组件是否已有数据（已有数据则设置表单不可读）
  businessPlanValue = {},
  businessInfoValue = {},
  showHintStr,
  isAreaProtect, // 是否有区域保护
  antiCollisionApprovalStatus,
  addressVal,
  salesFactorOfKWK, // 机会点表单使用（卡旺卡预估销售额）,该组件还被其他页面引用，其他页面是不会传该参数
  setSalesFactorOfKWK, // 机会点表单使用（卡旺卡预估销售额）
  isEditedBasicChancePointName,
  setEditedBasicChancePointName,
  tiledFormDataRef,
  customGatheringCategoryForYHT,
  setCustomGatheringCategoryForYHT,
  disabledArea, // 禁用开店区域点击查看详情
  isEdit = false, // 是否编辑
  expansionTaskClusterId,
  onAreaProtectionCollisionChange,
}) => {
  const { childList } = formData;


  /**
   * @description 是否是长列表展示时的第一group
   *    长列表时只有第一group下需要展示group的锚点
   * @return
   */
  const firstGroupOfLongList = useMemo(() => {
    return (isLongList && formData && isArray(wholeFormData.propertyGroupVOList) && wholeFormData.propertyGroupVOList.length && wholeFormData.propertyGroupVOList[0].id === formData.id);
  }, [wholeFormData, formData]);

  const anchorItems = useMemo(() => {
    if (firstGroupOfLongList) {
      // 长列表展示第一个tab时，将完整formData各tab下childList进行合并
      const items: any[] = [];
      wholeFormData.propertyGroupVOList.forEach((grp: any) => {
        isArray(grp.childList) && grp.childList.forEach((child: any) => {
          items.push({
            id: `title${child.id}`,
            title: child.name,
          });
        });
      });
      return items;
    }
    // 非长列表展示、或者长列表的第2个及以后group时，取tab下childList
    return childList.map((child: any) => ({
      id: `title${child.id}`,
      title: child.name,
    }));
  }, [childList]);

  // useEffect(() => {
  //   if (isLongList && scrollAccordingTab && active && +active === formData.id) {
  //     // 长表单tab切换时，自动滚动到tab对应内容
  //     // const element = document.getElementById(`group${formData.id}`);
  //     const targetEle = tabContentRefs.current.find((refItem) => refItem?.id === +active);
  //     targetEle?.el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //   }
  // }, [isLongList, active]);

  /**
   * @description 是否展示propertyList的二级标题
   * @param childItem 二级数据
   * @return 是否展示，默认true展示，如果第一项property是本身就带有小标题的特定组件就返回false不展示
   */
  const { showSecondLevelTitle } = useMethods({
    showSecondLevelTitle(childItem: any) {
      const firstItem = isArray(childItem?.propertyConfigVOList) ? childItem?.propertyConfigVOList[0] : null;

      // 匹配商圈有值时，展示的区域信息，或者周边测评信息，都是自带小标题，不展示二级标题，否则会出现连续展示两个标题的问题
      if (firstItem?.controlType === ControlType.MATCH_BUSINESS_CIRCLE.value) {
        /*
          匹配商圈组件的值
          未选地址时，textValue为null
          选地址不在区域内，textValue: "{\"lat\":30.283756,\"lng\":120.157653}"
          选地址在区域内，textValue: {"isInCluster":true,"clusterId":1052877,"planClusterId":null,"clusterName":"合肥凤凰文化广场","clusterTypeName":"商业区/商业体","clusterScore":"85.6","planStores":null,"openStores":0,"distance":20.57915686827509,"planSpots":null,"lat":31.809016,"lng":117.286636}
        */
        const valObj = JSON.parse(firstItem.textValue);
        const hasSelfTitle = typeof valObj === 'object' && isNotEmptyAny(valObj);
        return !hasSelfTitle;
      }

      // 基诺浦组件本身有小标题，处于第一个字段时不展示二级标题，否则会出现连续展示两个标题的问题
      const hide = firstItem?.controlType === ControlType.PROFIT_CAlCULATION_JNP.value;
      return !hide;
    },
  });

  return (
    <div className={cs('dynamicComCon', styles.dynamicComponent)}>
      {
        isArray(childList) ? (<>
          {
            childList.map((childItem: any, index: number) => (isArray(childItem?.propertyConfigVOList) && childItem?.propertyConfigVOList.some(property => property.isShow && (property.controlType !== ControlType.ASSOCIATED_RECORDS.value || showAssociatedRecords) && isShowWhenApprovalProcess({
              taskEntry: wholeFormData?.taskEntry,
              supportDirectApproval,
              propertyItem: property,
              isTraditionEvaluation,
              isChancepoint
            })) ? <Fragment key={index}>
                {showSecondLevelTitle(childItem) ? <V2Title
                  id={anchorItems[index].id}
                  type='H2'
                  divider
                  text={childItem.name}
                  className='pt-8 pb-16'
                /> : <></>}
                <Row gutter={24}>
                  {
                    isArray(childItem?.propertyConfigVOList)
                      ? childItem.propertyConfigVOList.map((item: any, idx: number) => <Fragment key={idx}>
                        <PropertyComponent
                          item={item}
                          form={form}
                          wholeFormData={wholeFormData}
                          isChancepoint={isChancepoint}
                          showAssociatedRecords={showAssociatedRecords}
                          isTraditionEvaluation={isTraditionEvaluation}
                          addressChange={addressChange}
                          mapMoveChange={mapMoveChange}
                          mapZoomChange={mapZoomChange}
                          updateCompValue={updateCompValue}
                          updateRelateShow={updateRelateShow}
                          supportDirectApproval={supportDirectApproval}
                          isFootprintValue={isFootprintValue}
                          businessPlanValue={businessPlanValue}
                          businessInfoValue={businessInfoValue}
                          showHintStr={showHintStr}
                          isAreaProtect={isAreaProtect}
                          antiCollisionApprovalStatus={antiCollisionApprovalStatus}
                          // addressVal={addressVal}
                          addressVal={addressVal}
                          salesFactorOfKWK={salesFactorOfKWK}
                          setSalesFactorOfKWK={setSalesFactorOfKWK}
                          isEditedBasicChancePointName={isEditedBasicChancePointName}
                          setEditedBasicChancePointName={setEditedBasicChancePointName}
                          tiledFormDataRef={tiledFormDataRef}
                          customGatheringCategoryForYHT={customGatheringCategoryForYHT}
                          setCustomGatheringCategoryForYHT={setCustomGatheringCategoryForYHT}
                          disabledArea={disabledArea}
                          // onValuesChange={onValuesChange}
                          isEdit={isEdit}
                          expansionTaskClusterId={expansionTaskClusterId}
                          onAreaProtectionCollisionChange={onAreaProtectionCollisionChange}
                        />
                      </Fragment>) : null
                  }
                </Row>

              </Fragment> : null))
          }
        </>) : null
      }

      {/* <V2Anchor
        getContainer={() => {
          // 长列表时关联包含了各tabs的dom，单tab内容时对应只包含该tab的dom
          const selectors: string = isLongList ? '.dynamicComponent' : '.dynamicComponent .dynamicComCon';
          const target: HTMLElement = document.querySelector(selectors) || document.body;
          // const target: HTMLElement = document.querySelector('.ant-drawer-content-wrapper .ant-drawer-body .dynamicComCon') || document.body;
          return target;
        }}
        className={cs(styles.anchorCon, anchorItems.length > 1 && (!isLongList || firstGroupOfLongList) ? '' : 'hide', isNotEmptyAny(anchorCustomStyle) ? '' : styles.defaultPostion)}
        style={isNotEmptyAny(anchorCustomStyle) ? anchorCustomStyle : {}}
      >
        { anchorItems.map(item => <Link key={item.id} href={`#${item.id}`} title={item.title} />) }
      </V2Anchor> */}
    </div>
  );
};

export default DynamicComponent;
